import React, { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing, Potenciador } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = 'es-419';
      document.documentElement.setAttribute('translate', 'no');
      document.title = 'MEGAPACK Funcional 365 — Todo tu año de funcional, listo';
    }
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandOrange selection:text-white notranslate" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <Hero data-id="element-3" />
      <SocialProof data-id="element-4" />
      <Testimonials1 data-id="element-5" />
      <Problem data-id="element-6" />
      <ProductTomos data-id="element-7" />
      <Bonuses data-id="element-8" />
      <UrgencyCounter data-id="element-9" />
      <Pricing data-id="element-10" />
      <Potenciador data-id="element-11" />
      <Testimonials2 data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <CostOfNotHaving data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}